(function () {
  function esc(s) {
    return String(s ?? '').replace(/[&<>"']/g, function (m) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }
  function hoverLink(label, url, img, caption) {
    var inner = url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener">' + esc(label) + '</a>' : '<span>' + esc(label) + '</span>';
    if (!img) return inner;
    return '<span class="hover-preview">' + inner + '<span class="hover-card">' +
      '<img loading="lazy" decoding="async" src="' + img + '" alt="' + esc(label) + '">' +
      (caption ? '<div class="hover-caption">' + esc(caption) + '</div>' : '') +
      '</span></span>';
  }
  function countSortValue(v) {
    var m = String(v || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 9999;
  }
  function initTool(root, rows, settings) {
    var panelSel = root.querySelector('[data-role="panel"]');
    var mountCategorySel = root.querySelector('[data-role="mount-category"]');
    var countSel = root.querySelector('[data-role="count"]');
    var orientationSel = root.querySelector('[data-role="orientation"]');
    var summary = root.querySelector('[data-role="summary"]');
    var results = root.querySelector('[data-role="results"]');
    var resetBtn = root.querySelector('[data-role="reset"]');

    var uniquePanels = Array.from(new Set(rows.map(function (r) { return r.panelBaseName; }))).sort();
    uniquePanels.forEach(function (v) {
      panelSel.insertAdjacentHTML('beforeend', '<option value="' + esc(v) + '">' + esc(v) + '</option>');
    });
    Array.from(new Set(rows.map(function (r) { return r.mountCategory; }))).sort().forEach(function (v) {
      mountCategorySel.insertAdjacentHTML('beforeend', '<option value="' + esc(v) + '">' + esc(v) + '</option>');
    });
    Array.from(new Set(rows.map(function (r) { return String(r.count); }))).sort(function (a,b) {
      return countSortValue(a) - countSortValue(b);
    }).forEach(function (v) {
      countSel.insertAdjacentHTML('beforeend', '<option value="' + esc(v) + '">' + esc(v) + '</option>');
    });

    orientationSel.innerHTML = '<option value="">Select orientation</option><option value="Landscape">Landscape</option><option value="Portrait">Portrait</option>';
    orientationSel.disabled = true;

    if (settings.defaultPanel && uniquePanels.includes(settings.defaultPanel)) {
      panelSel.value = settings.defaultPanel;
    }

    function getRows() {
      return rows.filter(function (r) {
        return (!panelSel.value || r.panelBaseName === panelSel.value) &&
          (!mountCategorySel.value || r.mountCategory === mountCategorySel.value) &&
          (!countSel.value || String(r.count) === countSel.value) &&
          (!orientationSel.value || r.orientation === orientationSel.value);
      });
    }

    function renderSummary(filtered) {
      var bits = [];
      if (panelSel.value) bits.push(panelSel.value);
      if (mountCategorySel.value) bits.push(mountCategorySel.value);
      if (countSel.value) bits.push(countSel.value + ' module(s)');
      if (orientationSel.value) bits.push(orientationSel.value);

      if (panelSel.value) {
        var row = filtered[0] || rows.find(function (r) { return r.panelBaseName === panelSel.value; });
        summary.innerHTML =
          '<h2 style="margin-top:0">' + esc(settings.results_heading || 'Filtered results') + '</h2>' +
          '<div class="hero-grid"><div class="hero-card"><div class="meta">' +
          '<div class="kicker">' + esc(settings.panel_label || 'Panel') + '</div>' +
          '<div class="name">' + hoverLink(row ? row.panelBaseName : panelSel.value, row ? row.panelUrl : '', row ? row.panelImage : '', 'Panel image') + '</div>' +
          '<div class="sub">' + esc(bits.join(' • ')) + '</div>' +
          '</div></div></div>';
      } else {
        summary.innerHTML =
          '<h2 style="margin-top:0">' + esc(settings.results_heading || 'Filtered results') + '</h2>' +
          '<div class="sub">' + esc(bits.join(' • ') || 'Showing all matches') + '</div>';
      }
    }

    function renderTable(filtered) {
      if (!filtered.length) {
        results.innerHTML = '<div class="empty">' + esc(settings.no_results || 'No matches found.') + '</div>';
        return;
      }
      results.innerHTML =
        '<table><thead><tr>' +
        '<th>' + esc(settings.panel_label || 'Panel') + '</th>' +
        '<th>' + esc(settings.mount_type_label || 'Type of Mount') + '</th>' +
        '<th>' + esc(settings.mount_option_label || 'Mount Option') + '</th>' +
        '<th>' + esc(settings.modules_label || '# of Modules') + '</th>' +
        '<th>' + esc(settings.orientation_label || 'Orientation') + '</th>' +
        '</tr></thead><tbody>' +
        filtered.map(function (r) {
          return '<tr>' +
            '<td><div class="primary">' + hoverLink(r.panelBaseName, r.panelUrl, r.panelImage, 'Panel image') + '</div></td>' +
            '<td>' + esc(r.mountCategory) + '</td>' +
            '<td><div class="primary">' + hoverLink(r.mount, r.mountUrl, r.mountImage, 'Mount image') + '</div>' +
            (r.manualUrl ? '<div class="secondary"><a href="' + esc(r.manualUrl) + '" target="_blank" rel="noopener">View manual</a></div>' : '') +
            '</td>' +
            '<td>' + esc(r.count) + '</td>' +
            '<td>' + esc(r.orientation) + '</td>' +
            '</tr>';
        }).join('') +
        '</tbody></table>';
    }

    function update() {
      var enableOrientation = Boolean(mountCategorySel.value || countSel.value);
      if (enableOrientation) {
        orientationSel.disabled = false;
        if (!orientationSel.value) orientationSel.value = 'Landscape';
      } else {
        orientationSel.value = '';
        orientationSel.disabled = true;
      }
      var nonPanelSelections = [mountCategorySel.value, countSel.value, orientationSel.value].filter(Boolean).length;
      if (nonPanelSelections === 0) {
        summary.innerHTML = '<h2 style="margin-top:0">Results</h2><div class="empty">' + esc(settings.empty_message || 'Choose a type of mount or number of modules to begin.') + '</div>';
        results.innerHTML = '';
        return;
      }
      var filtered = getRows();
      renderSummary(filtered);
      renderTable(filtered);
    }

    panelSel.addEventListener('change', update);
    mountCategorySel.addEventListener('change', update);
    countSel.addEventListener('change', update);
    orientationSel.addEventListener('change', update);
    resetBtn.addEventListener('click', function () {
      panelSel.value = settings.defaultPanel && uniquePanels.includes(settings.defaultPanel) ? settings.defaultPanel : '';
      mountCategorySel.value = '';
      countSel.value = '';
      orientationSel.value = '';
      orientationSel.disabled = true;
      update();
    });

    update();
  }

  function init() {
    document.querySelectorAll('[data-solar-mount-product-tool]').forEach(function (root) {
      var settingsNode = root.querySelector('script[type="application/json"]');
      var settings = settingsNode ? JSON.parse(settingsNode.textContent) : {};
      var dataUrl = root.getAttribute('data-source');
      fetch(dataUrl, { cache: 'no-cache' })
        .then(function (r) { return r.json(); })
        .then(function (rows) { initTool(root, rows, settings); })
        .catch(function () {
          root.innerHTML = '<div class="solar-mount-tool"><strong>Unable to load calculator data.</strong></div>';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();